let storeName = '';

export function setGAHelperStoreName(name) {
    storeName = name;
}

export function loadGAAsync() {
    const gaSrc = 'https://www.googletagmanager.com/gtag/js';
    const gaScript = document.createElement('script');
    gaScript.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() { dataLayer.push(arguments); }
        gtag('js', new Date());
        window.gtag = gtag;
    }
    gaScript.src = gaSrc;
    document.head.appendChild(gaScript);
}
